import React, { useRef, useState } from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import Image from 'next/image';
import _ from 'lodash';

import VideoWithThumbnail from 'components/VideoWithThumbnail';

const MobileSlider = ({ setGalleryContent, medias }) => {
  const sliderRef = useRef();

  const [sliderCurrentIndex, setSliderCurrentIndex] = useState(1);

  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (current) => setSliderCurrentIndex(current + 1),
  };

  const slideNext = () => {
    sliderRef.current.slickNext();
  };

  const slidePrevious = () => {
    sliderRef.current.slickPrev();
  };

  return (
    <div className="im-box im-box--white im-box--border-radius im-box--list-item im-box--padding-sm-15 d-block d-lg-none">
      <div className="im-image-gallery im-product-gallery">
        <div className="im-image-gallery__view">
          {
            medias.length > 0
              ? (
                <div className="im-slider-container product-detail-page-slider">
                  <div className="im-slider im-image-gallery__view__slider product-gallery-slider">
                    <Slider {...sliderSettings} ref={sliderRef} style={{ width: '100%' }}>
                      {_.map(medias, (media, index) => (
                        <div
                          onClick={() => setGalleryContent({ medias, showIndex: index })}
                          className="product-gallery-slider__item"
                          key={index}
                        >
                          {media.type === 'video' ? (
                            <VideoWithThumbnail
                              video={media}
                              width="350px"
                              height="263px"
                              notPlayable
                            />
                          ) : (
                            <Image
                              src={media.main}
                              width="350"
                              height="263"
                            />
                          )}
                        </div>
                      ))}
                    </Slider>
                  </div>
                  <div className="im-slider__arrows im-slider__arrows--type2">
                    <div className="im-slider__arrows__prev" onClick={() => slidePrevious()}>
                      <i className="fa-solid fa-angle-left" />
                    </div>
                    <div className="im-slider__arrows__next" onClick={() => slideNext()}>
                      <i className="fa-solid fa-angle-right" />
                    </div>
                  </div>
                  <div className="im-slider__counter">
                    <div className="im-slider__counter__count">
                      {`${sliderCurrentIndex}/${medias.length}`}
                    </div>
                  </div>
                </div>
              )
              : (
                <div className="product-gallery-slider__item">
                  <Image
                    src="/image/machine-detail-slider-placeholder.jpg"
                    width="640"
                    height="480"
                  />
                </div>
              )
          }
        </div>
      </div>
    </div>
  );
};

MobileSlider.propTypes = {
  setGalleryContent: PropTypes.func,
  medias: PropTypes.array,
};

export default MobileSlider;
